import { Component, OnInit, ViewChild } from '@angular/core';
import { ManningAgencyHeaderService } from '../manning-agency-header.service';
import { CookieService } from 'ngx-cookie-service';
import { ManningAgencyAdminService } from '../../core/manning-agency-admin.service';
import { ManningAgencyService } from '../../core/manning-agency.service';
import { ModalDirective, BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { UnderconstructionModalComponent } from '../../core/underconstruction-modal/underconstruction-modal.component';
import { DeleteModalComponent } from '../../core/delete-modal/delete-modal.component';
import { InviteSeafarerModalComponent } from '../../core/invite-seafarer-modal/invite-seafarer-modal.component';


@Component({
  selector: 'app-manning-agency-shortlist',
  templateUrl: './manning-agency-shortlist.component.html',
  styleUrls: ['./manning-agency-shortlist.component.css']
})
export class ManningAgencyShortlistComponent implements OnInit {
  @ViewChild('inviteModal') inviteModal: ModalDirective;
  bsModalRef: BsModalRef;
  bsConfig: Partial<BsDatepickerConfig> = {
    showWeekNumbers: false
  };
  minDate = new Date();
  maId;
  token;
  position;
  recentApplicants = {};
  ranks = [];
  seafarer = {};

  constructor(
    private headerService: ManningAgencyHeaderService,
    private cookieService: CookieService,
    private maService: ManningAgencyService,
    private manningAgencyService: ManningAgencyAdminService,
    private bsModalService: BsModalService
  ) { }

  ngOnInit() {
    this.headerService.changeHeader('shortlist');
    this.maId = this.cookieService.get('roleId');
    this.token = this.cookieService.get('token');
    this.manningAgencyService
      .getJobsShortlistedCount(this.token, null, null, this.maId)
      .subscribe(response => {
        if (response && response.success) {
          this.ranks = response.data.items;
        }
      });

    this.maService.getRecentShortlisted(this.token, this.maId)
      .subscribe(res => {
        if (res && res.success) {
          this.recentApplicants = res.data.items
            .reduce((prev, curr) => {
              prev[curr.dateApplied] = prev[curr.dateApplied] || [];
              prev[curr.dateApplied].push(curr);
              return prev;
            }, {});
        }
      });
  }

  getApplicants(position) {
    this.position = position;
    this.manningAgencyService
      .getJobsShortlisted(this.token, 1, 1000, null, null, this.maId, position)
      .subscribe(res => {
        if (res && res.success) {
          this.recentApplicants = res.data.items
            .reduce((prev, curr) => {
              prev[curr.dateApplied] = prev[curr.dateApplied] || [];
              prev[curr.dateApplied].push(curr);
              return prev;
            }, {});
        }
      });
  }

  showInviteModal(grp, idx) {

    const seafarer = this.recentApplicants[grp][idx];

    const initialState = {
      invitation: {
        maJobId: seafarer.maJobId,
        seafarerId: seafarer.seafarerId,
        maApplicantId: seafarer.maApplicantId,
        dateInvitation: null,
        timeInvitation: '',
        lookFor: ''
      },
      index: idx,
      token: this.token,
      data: this.recentApplicants[grp],
      seafarer: seafarer
    };

    this.bsModalService.show(InviteSeafarerModalComponent, {initialState});
  }

  delete(grp, idx) {

    const applicant = this.recentApplicants[grp][idx];

    const initialState = {
      id: applicant.maInviteId,
      token: this.token,
      deleteFunction: 'uninviteApplicant',
      seafarerId: applicant.seafarerId,
      index: idx,
      data: this.recentApplicants[grp],
      message: `${applicant.firstName} ${applicant.lastName}`,
      service: 'maService',
      callback: () => {
        this.ranks.forEach(r => {
          if (r.position === applicant.position) {
            r.count--;
          }
        })
      }
    };

    this.bsModalRef = this.bsModalService.show(DeleteModalComponent, {initialState});
  }

  filterCount(ranks) {
    return ranks.filter(r => !!r.count);
  }

}
